import {createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
    // 启蒙好课官网页面
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home.vue')
    },
    // 课程介绍
    {
        path: '/courseIntroduce',
        name: 'courseIntroduce',
        component: () => import(/* webpackChunkName: "test" */'@/views/courseIntroduce.vue')
    },

    // 个人信息保护政策（含历史版本切换，?v=YYYY-MM-DD）
    {
        path: '/policy',
        name: 'policy',
        component: () => import('@/views/policy/privacy/PolicyPrivacyPage.vue')
    },
    // 儿童隐私协议（含历史版本切换，?v=YYYY-MM-DD）
    {
        path: '/policychild',
        name: 'policychild',
        component: () => import('@/views/policy/child/PolicyChildPage.vue')
    },
    // 用户服务协议（仅当前版本，无历史版本）
    {
        path: '/policyprotocol',
        name: 'policyprotocol',
        component: () => import('@/views/policy/protocol/PolicyProtocolPage.vue')
    },
    // 隐私政策摘要
    {
        path: '/policysummary',
        name: 'policysummary',
        component: () => import('@/views/policysummary.vue')
    },
    // 第三方信息共享清单
    {
        path: '/policythirdshare',
        name: 'policythirdshare',
        component: () => import('@/views/policythirdshare.vue')
    },
    // 个人信息收集清单
    {
        path: '/policycollectlist',
        name: 'policycollectlist',
        component: () => import('@/views/policycollectlist.vue')
    },
    // 个人信息页
    {
        path: '/personalInfo',
        name: 'personalInfo',
        component: () => import('@/views/personalInfo/PersonalInfoView.vue')
    },
    // 个人信息导出页
    {
        path: '/personalInfo/export',
        name: 'personalInfoExport',
        component: () => import('@/views/personalInfo/PersonalInfoExport.vue')
    },
    // 其他的重定向到首页
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory('/'),
    routes
});

// console.log(222);
// router.beforeEach((to, from, next) => {
//     console.log(to);
// });

export default router;
